// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.7-next',
  revision: 'e372ac90f',
  branch: 'next',
  date: 'Mon, 22 Jun 2026 16:32:32 GMT'
};